import React, { useCallback, useEffect, useRef, useState } from 'react';
import { supabase } from './supabaseClient';
import { t } from './i18n';

// ============================================================
// Raportul lunar pentru client (etapa 7, bucata 7 — 15 octombrie 2026).
//
// Arhiva rapoartelor unui client, fiecare INGHETAT la generare (functia `raport-lunar`: singura pe
// 1 ale lunii pentru luna trecuta, sau la „Genereaza acum"). Ordinea capitolelor e a ei: comunitatea,
// continutul, moderarea, botul si abonatii, datele personale; costul AI doar la bifa.
// Raportul e al agentiei catre client, deci in romana si cu New Mind pe el. „Descarca PDF"
// deschide raportul singur intr-o fereastra si cheama tiparirea browserului (Salvare ca PDF).
// Doar super adminul (politica `rapoarte_lunare`).
// ============================================================

const LUNI = ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie', 'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie'];
const RETELE = { facebook: 'Facebook', instagram: 'Instagram', tiktok: 'TikTok', linkedin: 'LinkedIn', x: 'X', threads: 'Threads' };
const FUNCTII = { 'inbox-ai:triaj': 'triaj în Inbox', 'inbox-ai:raspunsuri': 'ciorne de răspuns', 'genereaza-texte': 'texte de postări', filtru: 'filtrul de comentarii' };
const MOTIVE = { insulta: 'insultă', vulgaritate: 'vulgaritate', eticheta: 'etichetă de atac', dispret: 'dispreț fără argument', spam: 'spam', amenintare: 'amenințare', altele: 'altele' };

const numeLuna = (iso) => { const [a, l] = String(iso).slice(0, 7).split('-'); return `${LUNI[Number(l) - 1]} ${a}`; };
const nr = (n) => (n === null || n === undefined ? '–' : Number(n).toLocaleString('ro-RO'));
const zi = (iso) => (iso ? new Date(iso).toLocaleDateString('ro-RO', { timeZone: 'Europe/Bucharest', day: 'numeric', month: 'long' }) : '');
const lei = (v) => Number(v || 0).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
// „1 comentariu", „20 de comentarii", „101 comentarii"
const cu = (n, unu, multe) => {
  const v = Number(n || 0);
  if (v === 1) return `1 ${unu}`;
  const c = v % 100;
  return `${nr(v)}${v >= 20 && (c === 0 || c >= 20) ? ' de' : ''} ${multe}`;
};

function lunaTrecuta() {
  const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Bucharest', year: 'numeric', month: '2-digit' })
    .formatToParts(new Date()).map(x => [x.type, x.value]));
  let a = Number(p.year); let l = Number(p.month) - 1;
  if (l === 0) { l = 12; a -= 1; }
  return { trecuta: `${a}-${String(l).padStart(2, '0')}`, curenta: `${p.year}-${p.month}` };
}

export function RapoarteLunare({ client }) {
  const [arhiva, setArhiva] = useState(null);
  const [ales, setAles] = useState(null);
  const [cuCost, setCuCost] = useState(false);
  const [lucrez, setLucrez] = useState(false);
  const [mesaj, setMesaj] = useState('');
  const { trecuta, curenta } = lunaTrecuta();
  const [lunaNoua, setLunaNoua] = useState(trecuta);
  const refRaport = useRef(null);

  const incarca = useCallback(async () => {
    const { data } = await supabase.from('rapoarte_lunare')
      .select('id, luna, date, generat_la, generat_de').eq('client_id', client.id).order('luna', { ascending: false });
    setArhiva(data || []);
    setAles(prev => (data || []).find(r => prev && r.id === prev.id) || (data || [])[0] || null);
  }, [client.id]);

  useEffect(() => { setAles(null); incarca(); }, [incarca]);

  async function genereaza() {
    setLucrez(true); setMesaj('');
    const { data, error } = await supabase.functions.invoke('raport-lunar', { body: { client_id: client.id, luna: lunaNoua } });
    setLucrez(false);
    if (error || !data || !data.ok) { setMesaj(t('raport', 'nuAMers') + (error ? error.message : '')); return; }
    await incarca();
    setMesaj(t('raport', 'generat'));
  }

  function descarca() {
    if (!refRaport.current) return;
    const w = window.open('', '_blank');
    if (!w) { alert(t('raport', 'fereastraBlocata')); return; }
    w.document.write(`<!doctype html><html lang="ro"><head><meta charset="utf-8"><title>Raport ${client.nume} — ${numeLuna(ales.luna)}</title>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;600&family=DM+Serif+Display&display=swap" rel="stylesheet">
      <style>body{margin:0;font-family:'DM Sans',Arial,sans-serif;color:#1F2937;background:#fff}@page{size:A4;margin:14mm}
      .nu-tipari{display:none}</style></head><body>${refRaport.current.outerHTML}</body></html>`);
    w.document.close();
    setTimeout(() => { w.focus(); w.print(); }, 700);
  }

  if (arhiva === null) return <div className="pagina"><p>{t('raport', 'seIncarca')}</p></div>;

  return (
    <div className="pagina">
      <div className="pagina-header">
        <div>
          <h1 className="pagina-titlu">{t('raport', 'titlu')}</h1>
          <p className="pagina-subtitlu">{t('raport', 'subtitlu')}</p>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center', marginBottom: 14 }}>
        <select value={ales ? ales.id : ''} onChange={e => setAles(arhiva.find(r => String(r.id) === e.target.value) || null)}
          style={{ padding: '8px 10px', borderRadius: 8, border: '1.5px solid #D1E8DA', fontSize: 14 }}>
          {!arhiva.length && <option value="">{t('raport', 'arhivaGoala')}</option>}
          {arhiva.map(r => <option key={r.id} value={r.id}>{numeLuna(r.luna)}</option>)}
        </select>
        <label style={{ fontSize: 14, display: 'flex', alignItems: 'center', gap: 6 }}>
          <input type="checkbox" checked={cuCost} onChange={e => setCuCost(e.target.checked)} /> {t('raport', 'cuCost')}
        </label>
        <button type="button" className="btn-principal" disabled={!ales} onClick={descarca}>{t('raport', 'descarca')}</button>
        <span style={{ marginLeft: 'auto', display: 'flex', gap: 8, alignItems: 'center' }}>
          <select value={lunaNoua} onChange={e => setLunaNoua(e.target.value)}
            style={{ padding: '8px 10px', borderRadius: 8, border: '1.5px solid #D1E8DA', fontSize: 14 }}>
            <option value={trecuta}>{numeLuna(trecuta)}</option>
            <option value={curenta}>{numeLuna(curenta)} ({t('raport', 'panaAzi')})</option>
          </select>
          <button type="button" className="btn-secundar" disabled={lucrez} onClick={genereaza}>
            {lucrez ? t('raport', 'seGenereaza') : t('raport', 'genereaza')}
          </button>
        </span>
      </div>
      {mesaj && <p style={{ fontSize: 13, color: '#1A6B3C' }} role="status">{mesaj}</p>}
      {ales && (
        <p style={{ fontSize: 12, color: '#4B5563', margin: '0 0 10px' }}>
          {t('raport', 'generatLa', { data: new Date(ales.generat_la).toLocaleString('ro-RO', { timeZone: 'Europe/Bucharest' }), cum: ales.generat_de === 'cron' ? t('raport', 'automat') : t('raport', 'deMana') })}
        </p>
      )}
      {!ales && <div style={{ background: '#F4FAF6', border: '1.5px solid #D1E8DA', borderRadius: 12, padding: 20 }}>{t('raport', 'nimic')}</div>}
      {ales && <div ref={refRaport}><Raport d={ales.date} cuCost={cuCost} /></div>}
    </div>
  );
}

// Raportul propriu-zis, in romana, pentru client. Stilurile sunt in linie: aceeasi pagina se
// tipareste si in fereastra separata a PDF-ului.
function Raport({ d, cuCost }) {
  const S = {
    foaie: { background: '#fff', border: '1px solid #E5EFE9', borderRadius: 14, padding: '32px 36px', maxWidth: 820, color: '#1F2937', fontFamily: "'DM Sans', Arial, sans-serif" },
    antet: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', borderBottom: '3px solid #1A6B3C', paddingBottom: 14, marginBottom: 22 },
    marca: { fontFamily: "'DM Serif Display', Georgia, serif", fontSize: 26, color: '#0F3D22', letterSpacing: 1 },
    titlu: { fontFamily: "'DM Serif Display', Georgia, serif", fontSize: 30, color: '#0F3D22', margin: '0 0 4px' },
    cap: { fontFamily: "'DM Serif Display', Georgia, serif", fontSize: 21, color: '#0F3D22', margin: '26px 0 10px', borderBottom: '1px solid #D1E8DA', paddingBottom: 6 },
    cifre: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 10, margin: '8px 0' },
    cifra: { background: '#F4FAF6', borderRadius: 10, padding: '10px 12px' },
    mare: { fontFamily: "'DM Serif Display', Georgia, serif", fontSize: 26, color: '#0F3D22', lineHeight: 1.1 },
    mic: { fontSize: 12.5, color: '#374151', marginTop: 2 },
    rand: { fontSize: 13.5, padding: '5px 0', borderBottom: '1px solid #F0F4F2' },
    nota: { fontSize: 12, color: '#4B5563', marginTop: 6 },
  };
  const Cifra = ({ n, text }) => <div style={S.cifra}><div style={S.mare}>{nr(n)}</div><div style={S.mic}>{text}</div></div>;
  const c = d.comunitatea || {}; const p = d.continutul || {}; const m = d.moderarea || {}; const b = d.botul || {};
  const fb = p.facebook; const ig = p.instagram;

  return (
    <div style={S.foaie}>
      <div style={S.antet}>
        <div>
          <div style={{ fontSize: 13, color: '#374151', textTransform: 'uppercase', letterSpacing: 1.5 }}>Raport lunar</div>
          <h1 style={S.titlu}>{d.client ? d.client.nume : ''}</h1>
          <div style={{ fontSize: 15, color: '#374151' }}>{numeLuna(d.luna)}{d.client && d.client.functie ? ` · ${d.client.functie}` : ''}</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={S.marca}>NEW MIND</div>
          <div style={{ fontSize: 11, color: '#1A6B3C', letterSpacing: 3 }}>NM SOCIAL</div>
        </div>
      </div>

      <h2 style={S.cap}>1. Comunitatea</h2>
      <div style={S.cifre}>
        <Cifra n={c.comentarii} text="comentarii primite" />
        <Cifra n={c.raspunsuri_publice} text="răspunsuri publice trimise" />
        <Cifra n={c.mesaje_private_primite} text={`mesaje private primite, în ${cu(c.conversatii, 'conversație', 'conversații')}`} />
        <Cifra n={c.mesaje_private_trimise} text="mesaje private trimise" />
        <Cifra n={c.raspunsuri_private_la_comentarii} text="răspunsuri în privat la comentarii" />
        <Cifra n={c.mentiuni} text="mențiuni ale paginii" />
      </div>
      {Array.isArray(c.cele_mai_discutate) && c.cele_mai_discutate.length > 0 && <>
        <div style={{ fontWeight: 600, fontSize: 14, margin: '14px 0 4px' }}>Cele mai discutate postări</div>
        {c.cele_mai_discutate.map((x, i) => (
          <div key={i} style={S.rand}><strong>{cu(x.comentarii, 'comentariu', 'comentarii')}</strong> · {RETELE[x.retea] || ''} {x.data ? '· ' + zi(x.data) : ''} — {x.text || '(fără text)'}</div>
        ))}
      </>}

      <h2 style={S.cap}>2. Conținutul</h2>
      <div style={S.cifre}>
        <Cifra n={p.publicate} text="postări publicate prin NM Social" />
        {Object.entries(p.pe_retea || {}).map(([r, n]) => <Cifra key={r} n={n} text={`pe ${RETELE[r] || r}`} />)}
        {p.postate_direct_pe_pagina > 0 && <Cifra n={p.postate_direct_pe_pagina} text="postate direct pe pagină" />}
      </div>
      {fb && fb.total && <>
        <div style={{ fontWeight: 600, fontSize: 14, margin: '14px 0 4px' }}>Facebook</div>
        <div style={S.cifre}>
          {fb.urmaritori !== null && fb.urmaritori !== undefined && <Cifra n={typeof fb.urmaritori === 'object' ? fb.urmaritori.total : fb.urmaritori} text="urmăritori" />}
          {fb.vizualizari && fb.vizualizari.vizualizari !== null && fb.vizualizari.vizualizari !== undefined && <Cifra n={fb.vizualizari.vizualizari} text="vizualizări" />}
          {fb.vizualizari && fb.vizualizari.vizionari_video !== null && fb.vizualizari.vizionari_video !== undefined && <Cifra n={fb.vizualizari.vizionari_video} text="vizionări video" />}
          <Cifra n={fb.total.reactii} text="reacții la postări" />
          <Cifra n={fb.total.comentarii} text="comentarii la postări" />
          <Cifra n={fb.total.distribuiri} text="distribuiri" />
          {fb.total_pagina && fb.total_pagina.vizite !== undefined && <Cifra n={fb.total_pagina.vizite} text="vizite pe pagină" />}
        </div>
      </>}
      {ig && ig.total && <>
        <div style={{ fontWeight: 600, fontSize: 14, margin: '14px 0 4px' }}>Instagram</div>
        <div style={S.cifre}>
          {ig.urmaritori !== null && ig.urmaritori !== undefined && <Cifra n={typeof ig.urmaritori === 'object' ? ig.urmaritori.total : ig.urmaritori} text="urmăritori" />}
          {ig.total_pagina && ig.total_pagina.acoperire !== undefined && ig.total_pagina.acoperire !== null && <Cifra n={ig.total_pagina.acoperire} text="oameni care au văzut contul (acoperire)" />}
          {ig.total_pagina && ig.total_pagina.conturi_implicate !== undefined && ig.total_pagina.conturi_implicate !== null && <Cifra n={ig.total_pagina.conturi_implicate} text="conturi care au interacționat" />}
          <Cifra n={ig.total.reactii} text="aprecieri" />
          <Cifra n={ig.total.comentarii} text="comentarii" />
          <Cifra n={ig.total.distribuiri} text="distribuiri" />
        </div>
      </>}
      {fb && Array.isArray(fb.cele_mai_bune) && fb.cele_mai_bune.some(x => x.vizualizari) && <>
        <div style={{ fontWeight: 600, fontSize: 14, margin: '14px 0 4px' }}>Cele mai bune postări pe Facebook</div>
        {fb.cele_mai_bune.map((x, i) => (
          <div key={i} style={S.rand}>
            {x.vizualizari !== null && x.vizualizari !== undefined ? <strong>{cu(x.vizualizari, 'vizualizare', 'vizualizări')}</strong> : null}
            {x.oameni ? ` · ${cu(x.oameni, 'om', 'oameni')}` : ''}{x.clicuri ? ` · ${cu(x.clicuri, 'clic', 'clicuri')}` : ''}
            {x.data ? ` · ${zi(x.data)}` : ''} — {x.text || '(fără text)'}
          </div>
        ))}
      </>}
      {Array.isArray(p.lista) && p.lista.length > 0 && <>
        <div style={{ fontWeight: 600, fontSize: 14, margin: '14px 0 4px' }}>Postările lunii</div>
        {p.lista.map((x, i) => (
          <div key={i} style={S.rand}>{zi(x.data)} · {RETELE[x.retea] || x.retea}{x.format ? ' · ' + x.format : ''} — {x.text || '(fără text)'}</div>
        ))}
      </>}
      {(fb || ig) && <div style={S.nota}>Statisticile vin de la Meta pentru ultimele {fb ? fb.perioada_zile : ig.perioada_zile} zile până la data raportului.</div>}

      <h2 style={S.cap}>3. Moderarea comentariilor</h2>
      {m.citite ? <>
        <div style={S.cifre}>
          <Cifra n={m.citite} text="comentarii citite de filtru" />
          <Cifra n={m.ascunse} text="ascunse" />
          <Cifra n={m.blocati} text="autori blocați" />
          <Cifra n={m.aratate_omului} text="lăsate omului să hotărască" />
          <Cifra n={m.ciorne_cerute} text="răspunsuri pregătite" />
        </div>
        {Object.keys(m.motive || {}).length > 0 && (
          <div style={S.rand}>De ce s-au ascuns: {Object.entries(m.motive).map(([k, n]) => `${MOTIVE[k] || k} ${nr(n)}`).join(' · ')}</div>
        )}
        {Array.isArray(m.exemple_ascunse) && m.exemple_ascunse.length > 0 && <>
          <div style={{ fontWeight: 600, fontSize: 14, margin: '10px 0 4px' }}>Exemple de comentarii ascunse (fără nume)</div>
          {m.exemple_ascunse.map((x, i) => <div key={i} style={{ ...S.rand, fontStyle: 'italic' }}>„{x}”</div>)}
        </>}
        {m.de_la && <div style={S.nota}>Filtrul a lucrat începând cu {zi(m.de_la)}. Nimic nu s-a șters: ascunderea se poate întoarce oricând.</div>}
      </> : <div style={S.rand}>Filtrul de comentarii n-a fost pornit luna aceasta.</div>}

      <h2 style={S.cap}>4. Botul de mesaje și abonații</h2>
      {(b.dm_trimise || b.abonati_total || b.mesaje_catre_abonati) ? (
        <div style={S.cifre}>
          <Cifra n={b.dm_trimise} text="mesaje trimise de bot la comentarii" />
          <Cifra n={b.au_apasat} text="oameni care au răspuns" />
          <Cifra n={b.abonati_noi} text="abonați noi" />
          <Cifra n={b.abonati_total} text="abonați în total" />
          <Cifra n={b.mesaje_catre_abonati} text="mesaje către abonați" />
        </div>
      ) : <div style={S.rand}>Botul de mesaje n-a fost pornit luna aceasta.</div>}

      <h2 style={S.cap}>5. Date personale</h2>
      <div style={S.rand}>
        {d.gdpr && d.gdpr.cereri_de_stergere
          ? `${cu(d.gdpr.cereri_de_stergere, 'cerere de ștergere a datelor îndeplinită', 'cereri de ștergere a datelor îndeplinite')}.`
          : 'Nicio cerere de ștergere a datelor.'}
      </div>

      {cuCost && d.cost_ai && <>
        <h2 style={S.cap}>6. Costul inteligenței artificiale</h2>
        <div style={{ ...S.rand, fontSize: 15 }}><strong>{lei(d.cost_ai.lei)} lei</strong> ({Number(d.cost_ai.usd || 0).toLocaleString('ro-RO', { maximumFractionDigits: 4 })} $)</div>
        {Object.entries(d.cost_ai.pe_functie || {}).map(([k, v]) => (
          <div key={k} style={S.rand}>{FUNCTII[k] || k}: {lei(v.usd * (d.cost_ai.curs || 4.6))} lei</div>
        ))}
        {d.cost_ai.lei_pe_cheia_clientului > 0 && (
          <div style={S.rand}>Din care {lei(d.cost_ai.lei_pe_cheia_clientului)} lei au mers pe cheia dumneavoastră Claude și au fost plătiți direct la Anthropic.</div>
        )}
        <div style={S.nota}>Cost real, din consumul raportat de Anthropic, la tariful oficial; în lei la cursul {String(d.cost_ai.curs || 4.6).replace('.', ',')}.</div>
      </>}

      <div style={{ marginTop: 30, fontSize: 11, color: '#4B5563', borderTop: '1px solid #E5EFE9', paddingTop: 10 }}>
        New Mind · NM Social · raport generat automat din datele aplicației
      </div>
    </div>
  );
}

// Banda de pe Acasa (hotararea ei: sa stie cand sunt gata rapoartele), in primele 7 zile ale lunii.
export function BandaRapoarte() {
  const [n, setN] = useState(0);
  const { trecuta } = lunaTrecuta();
  useEffect(() => {
    const ziua = Number(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Bucharest', day: '2-digit' }).format(new Date()));
    if (ziua > 7) return;
    (async () => {
      const { count } = await supabase.from('rapoarte_lunare').select('id', { count: 'exact', head: true }).eq('luna', trecuta + '-01');
      setN(count || 0);
    })();
  }, [trecuta]);
  if (!n) return null;
  return (
    <div style={{ background: '#F4FAF6', border: '1.5px solid #1A6B3C', borderRadius: 12, padding: '10px 14px', marginBottom: 16, fontSize: 14 }}>
      {t('raport', 'banda', { luna: numeLuna(trecuta), n })}
    </div>
  );
}
